export default __webpack_public_path__ + "static/media/Digiscape_CoBenefits_ConceptualFigure_2023-04-03.d87882ba.png";